<template>
  <div>
    <PageTable />
  </div>
</template>
<script>
import PageTable from './components/table'
export default {
  name: 'plan-noticeProductionOrder',
  components: { PageTable },
}
</script>
